import { requirePermissions } from '@/shared/utils';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { AdvisoriesIdPage } from '../../../../features/advisory/components/advisories-id-page.component';

export const Route = createFileRoute('/_app/advisories/$id/')({
  component: AdvisoriesIdPage,
  beforeLoad: async () => {
    const hasPermission = await requirePermissions(['parties.advisories.read']);
    if (!hasPermission) {
      throw redirect({ to: '/dashboard' });
    }
  },
});
